import {
  innersvg,
  CashCard,
  innersvg2,
  CashCard2,
  innersvg3,
  CashCard3,
  innersvg4,
  CashCard4,
} from "./../../../Public/assets/index";

export const list1 = {
  title: "Store money in up to 6 currencies",
  inner: innersvg,
  icon: CashCard,
  bgcolor: "#FFE2C7",
  circularbg: "#FFF1E5",
  boxShadow: "10px 10px 40px 0px #E9CEB6A3, -10px -10px 20px 0px #FFFFFF",
  divshadow: "10px 10px 20px 0px #D9BBA2, -10px -10px 20px 0px #FFFFFF",
};

export const list2 = {
  title: "More than 40% savings on future forex costs",
  inner: innersvg2,
  icon: CashCard2,
  bgcolor: "#FFE9FD",
  circularbg: "#FFE9FD",
  boxShadow: "10px 10px 20px 0px #E7BFE3, -10px -10px 20px 0px #FFFFFF",
  divshadow: "10px 10px 20px 0px #E7BFE3, -10px -10px 20px 0px #FFFFFF",
};

export const list3 = {
  title: "Multi-currency interest rate products",
  inner: innersvg3,
  icon: CashCard3,
  bgcolor: "#D0EBFF",
  circularbg: "#D0EBFF",
  boxShadow: "10px 10px 20px 0px #BFDEF5, -10px -10px 20px 0px #FFFFFF",
  divshadow: "10px 10px 20px 0px #BFDEF5, -10px -10px 20px 0px #FFFFFF",
};

export const list4 = {
  title: "Instant money movement into 30+ countries",
  inner: innersvg4,
  icon: CashCard4,
  bgcolor: "#E1FBF7",
  circularbg: "#E1FBF7",
  boxShadow: "10px 10px 20px 0px #A4DED5, -10px -10px 20px 0px #FFFFFF",
  divshadow: "10px 10px 20px 0px #A4DED5, -10px -10px 20px 0px #FFFFFF",
};
